import { Logger } from '../utilities/logger';
import { AbstractComponent } from '../components/abstract-component';
/**
 * Base for a consent view. A view is considered a component, that shows consent options to the user, e.g. within a
 * modal or a banner or something similar. In any way, such a view requires some input from the user.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class AbstractView extends AbstractComponent {
    constructor(api, container) {
        super(api, container);
        Logger.debug('abstract-view', 'Starting to construct.');
        const document = this.container.querySelector(':scope > [role="document"]');
        if (!document) {
            throw new Error('Document container missing.');
        }
        this.document = document;
        this.api.emitter.on('acceptAll', () => {
            this.hide();
        });
        this.api.emitter.on('rejectAll', () => {
            this.hide();
        });
        this.api.emitter.on('save', () => {
            this.hide();
        });
        this.api.emitter.on('reset', () => {
            this.show();
        });
        Logger.debug('abstract-view', 'Finished constructing.');
    }
}
